import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { FileUploader } from 'ng2-file-upload';

import { URL_API } from './../constante';

import { Documento } from './documento';
import { DocumentoService } from './documento.service';

import { TipoService } from './../tipos/tipo.service';
import { Tipo } from './../tipos/tipo';

import { TipoCertificadoService } from './../tipos_certificados/tipo_certificado.service';
import { TipoCertificado } from './../tipos_certificados/tipo_certificado';

import { Variavel } from './../variaveis/variavel';
import { Assinatura } from './../assinaturas/assinatura';

import { UnidadeService } from './../unidades/unidade.service';
import { Unidade } from './../unidades/unidade';

import { CentroService } from './../centros/centro.service';
import { Centro } from './../centros/centro';

import { GrupoService } from './../grupos/grupo.service';
import { Grupo } from './../grupos/grupo';
import { VariavelPadrao } from 'app/tipos_certificados/variaveis_padroes';
import { Utils } from './../shared/utils';

const URL = URL_API + '/documentos';

declare var Materialize:any;

@Component({
  selector: 'app-documentos',
  templateUrl: './criar.component.html',
  styleUrls: ['./documentos.component.css'],
  providers: [DocumentoService, TipoService, TipoCertificadoService, UnidadeService, CentroService, GrupoService, Utils]
})

export class CriarDocumentoComponent implements OnInit, AfterViewChecked {
  documento: Documento;
  titulo: string = "Novo Documento";
  tipos: Tipo[];
  tipoCertificados: TipoCertificado[];
  unidades: Unidade[];
  centros: Centro[];
  grupos: Grupo[];
  passos: string[] = ['documento', 'variaveis', 'corpo', 'assinaturas', 'visualizar'];
  passo_atual: string = 'documento';
  variaveis_ativo: any[];
  uploader: FileUploader = new FileUploader({url: URL});
  public busy: Promise<any>;
  assinadores: any[] = [];

  constructor(
    private documentoService: DocumentoService,
    private tipoService: TipoService,
    private tipoCertificadoService: TipoCertificadoService,
    private unidadeService: UnidadeService,
    private centroService: CentroService,
    private grupoService: GrupoService,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router,
    private utils: Utils
  ) {
    this.documento = new Documento();

    
  }

  getDocumento(): void {
    this.route.params.forEach((params: Params) => {
      let id = params['id'];

      if(id !== undefined ){
        this.busy = this.documentoService.getDocumento(id)
          .then(documento => this.documento = documento);
      }
    });
  }

  getUnidades(): void{
    this.unidadeService.getUnidadesPorCentro(this.documento.centro_id)
        .then((response) => this.unidades = response);
  }

  getGrupos(): void{
    this.grupoService.getAllGrupos()
        .then((response) => this.grupos = response);
  }

  getCentros(): void{
    this.centroService.getCentros()
        .then((response) => this.centros = response);
  }

  addVariavel(): void{
    this.documento.variaveis.push(new Variavel());
  }

  addAssinatura():void{
    this.documento.certificado.assinaturas.push(new Assinatura());
  }

  removeVariavel(variavel: any): void{
    let indice = this.documento.variaveis.indexOf( variavel );
    this.documento.variaveis.splice(indice, 1);
  }

  removeAssinatura(assinatura: any): void{
    let indice = this.documento.certificado.assinaturas.indexOf( assinatura );
    this.documento.certificado.assinaturas.splice(indice, 1);
  }

  pegarCertificado(): void{
    let tipo_certificado_id = this.documento.certificado.tipo;
   

    this.busy = this.tipoCertificadoService.getTipoCertificado(tipo_certificado_id)
          .then(tipoCertificado => this.addVariaveisPadroes(tipoCertificado) );
  }

  addVariaveisPadroes(tipoCertificado:any):void{
    let variaveis_padroes = tipoCertificado.variaveis_padroes;

    for(let variavel of this.documento.variaveis){
      if(variavel.padrao || variavel.identificador === undefined){
        this.removeVariavel(variavel);
      }
    }

    if(variaveis_padroes.length > 0){
      for(let variavel_padrao of variaveis_padroes){
        let variavel = new Variavel();

        variavel.identificador = variavel_padrao.identificador;
        variavel.descricao = variavel_padrao.descricao;
        variavel.tipo_id = variavel_padrao.tipo_id;
        variavel.padrao = true;

        this.documento.variaveis.push(variavel);

      }      
    }
  }

  salvar(): void {
    if (!this.validarAssinaturas()) {
      return;
    }

    this.busy = this.documentoService.saveDocumento(this.documento)
          .then(() => this.goBack());
  }

  validarAssinaturas(): boolean {
    if (!this.documento.certificado.assinatura_digital) {
      return true;
    }

    if (!this.documento.grupo_id) {
      this.utils.flashMessage('Selecione o grupo do certificado antes de configurar assinaturas digitais.', 'warning');
      return false;
    }

    const assinaturas = this.documento.certificado.assinaturas.filter((a: Assinatura) => !a.destroy);
    if (assinaturas.length === 0) {
      this.utils.flashMessage('Informe ao menos um assinador.', 'warning');
      return false;
    }

    for (const assinatura of assinaturas) {
      if (!assinatura.usuario_id || !assinatura.posicao || !assinatura.cargo) {
        this.utils.flashMessage('Preencha assinador, posição e cargo em todas as assinaturas digitais.', 'warning');
        return false;
      }
    }

    return true;
  }

  carregarAssinadores(): void {
    if (!this.documento.grupo_id) {
      this.assinadores = [];
      return;
    }

    this.grupoService.getAssinadoresGrupo(this.documento.grupo_id)
      .then((response) => this.assinadores = response);
  }

  toggleTipoAssinatura(digital: boolean): void {
    if (!!this.documento.certificado.assinatura_digital === digital) {
      return;
    }

    this.documento.certificado.assinatura_digital = digital;
    this.limparAssinaturas();

    if (digital) {
      this.carregarAssinadores();
    }
  }

  limparAssinaturas(): void {
    let assinaturas: Assinatura[] = [];

    for (let assinatura of this.documento.certificado.assinaturas) {
      if (assinatura.id) {
        assinatura.destroy = true;
        assinaturas.push(assinatura);
      }
    }

    assinaturas.push(new Assinatura());
    this.documento.certificado.assinaturas = assinaturas;
  }

  onAssinadorChange(assinatura: Assinatura): void {
    const usuario = this.assinadores.find((u) => u.id == assinatura.usuario_id);
    if (usuario) {
      assinatura.nome = usuario.nome;
    }
  }

  upload(event: any, assinatura:Assinatura):void{
    let listaArquivo: FileList = event.target.files;
    let arquivo: File = listaArquivo[0];
    assinatura.arquivo = arquivo;
  }

  getTipoCertificados(): void{
    this.tipoCertificadoService.getTipos()
        .then((response) => this.processarTipoCertificados(response));
  }

  processarTipoCertificados(response:any[]): void{
    this.tipoCertificados = response.filter(function (tipoCertificado) {
        return tipoCertificado.ativo == true;
    });
  }

  getTipos(): void{
    this.tipoService.getTipos()
        .then((response) => this.tipos = response);
  }

  onSelect(): void{
    console.log(this.documento);
  }

  goBack(): void {
     this.router.navigate(['/documentos']);
  }

  goHome(): void {
    this.router.navigate(['/']);
 }

  proximoPassos(): void{
    switch(this.passo_atual){
      case 'documento':
        this.passo_atual = 'variaveis';
        break;
      case 'variaveis':
        this.passo_atual = 'corpo';
        break;
      case 'corpo':
        this.passo_atual = 'assinaturas';
        if (this.documento.certificado.assinatura_digital) {
          this.carregarAssinadores();
        }
        break;
      case 'assinaturas':
        this.passo_atual = 'visualizar';
        break;
    }
  }

  anteriorPassos(): void{
    switch(this.passo_atual){
      case 'visualizar':
        this.passo_atual = 'corpo';
        break;
      case 'variaveis':
        this.passo_atual = 'documento';
        break;
      case 'corpo':
        this.passo_atual = 'variaveis';
        break;
      case 'assinaturas':
        this.passo_atual = 'corpo';
        break;
    }
  }

  verificaCorpo(): void{
    let variaveis = this.documento.variaveis;
    let i:any;
    let regex:any;
    let corpo:string;

    for( i in variaveis){
      regex = new RegExp("%" + variaveis[i].identificador +"%");

      corpo = this.documento.certificado.corpo;
      if(regex.test(corpo)){
        variaveis[i].usado = true;
      } else {
        variaveis[i].usado = false;
      }
    }
  }

  validate(): void{

  }


  ngOnInit() {
    //this.getDocumento();
    this.getTipos();
    this.getTipoCertificados();
    this.getCentros();
    this.getGrupos();

   
  }

  ngAfterViewChecked() {
    Materialize.updateTextFields();
  }

}



// WEBPACK FOOTER //
// ./src/app/documentos/criar.component.ts